var _g, _path, _path2, _path3, _path4, _path5, _path6;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGoogleChat(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0.00 0.00 311.00 320.00",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    strokeWidth: 2,
    fill: "none",
    strokeLinecap: "butt"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#7e916f",
    vectorEffect: "non-scaling-stroke",
    d: "   M 76.37 0.51   L 76.38 76.98"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#1375eb",
    vectorEffect: "non-scaling-stroke",
    d: "   M 76.38 76.98   L 0.00 76.96"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#f3801d",
    vectorEffect: "non-scaling-stroke",
    d: "   M 235.08 1.09   Q 234.92 1.15 234.81 1.22   Q 234.64 1.31 234.64 1.50   L 234.62 77.01"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#7eb426",
    vectorEffect: "non-scaling-stroke",
    d: "   M 234.62 77.01   Q 234.60 77.01 234.57 77.01"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#91a080",
    vectorEffect: "non-scaling-stroke",
    d: "   M 76.41 77.01   Q 76.40 77.00 76.38 76.98"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#75783e",
    vectorEffect: "non-scaling-stroke",
    d: "   M 310.53 76.77   L 234.62 77.01"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#138495",
    vectorEffect: "non-scaling-stroke",
    d: "   M 76.43 182.69   L 0.00 182.67"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#00983a",
    vectorEffect: "non-scaling-stroke",
    d: "   M 76.44 259.13   L 76.43 220.85"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#0066da",
    d: "   M 76.37 0.51   L 76.38 76.98   L 0.00 76.96   L 0.00 20.77   Q 0.85 14.81 3.53 10.76   Q 10.14 0.74 22.75 0.67   Q 49.41 0.53 76.37 0.51   Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fbbc04",
    d: "   M 76.37 0.51   L 233.79 0.53   A 1.61 1.57 -26.7 0 1 234.71 0.82   L 235.08 1.09   Q 234.92 1.15 234.81 1.22   Q 234.64 1.31 234.64 1.50   L 234.62 77.01   Q 234.60 77.01 234.57 77.01   L 76.41 77.01   Q 76.40 77.00 76.38 76.98   L 76.37 0.51   Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#ea4335",
    d: "   M 235.08 1.09   L 310.53 76.77   L 234.62 77.01   L 234.64 1.50   Q 234.64 1.31 234.81 1.22   Q 234.92 1.15 235.08 1.09   Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#2684fc",
    d: "   M 0.00 76.96   L 76.38 76.98   Q 76.40 77.00 76.41 77.01   L 76.43 182.69   L 0.00 182.67   L 0.00 76.96   Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#00ac47",
    d: "   M 310.53 76.77   L 311.00 77.11   L 311.00 239.01   Q 308.34 253.54 295.94 257.78   Q 291.52 259.30 282.91 259.28   Q 227.02 259.19 169.99 259.11   Q 161.71 259.10 153.19 259.23   Q 152.72 259.24 152.39 259.57   Q 124.49 287.34 96.39 315.59   C 93.52 318.48 90.27 320.09 86.15 319.48   Q 80.39 318.63 77.66 313.54   Q 76.51 311.38 76.49 305.66   Q 76.42 282.47 76.44 259.13   L 76.43 220.85   L 114.21 183.07   A 1.79 1.77 22.3 0 1 115.47 182.55   L 233.77 182.59   A 0.83 0.83 0.0 0 0 234.60 181.76   L 234.57 77.01   Q 234.60 77.01 234.62 77.01   L 310.53 76.77   Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#00832d",
    d: "   M 76.43 182.69   L 76.43 220.85   L 76.44 259.13   Q 52.47 259.27 28.91 259.22   Q 19.09 259.20 14.76 257.68   Q 2.62 253.44 0.00 238.88   L 0.00 182.67   L 76.43 182.69   Z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleChat);
export default __webpack_public_path__ + "static/media/google_chat.e36306c8efe007556c9e8dbdf44d90c5.svg";
export { ForwardRef as ReactComponent };